import { Injectable, Injector } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BaseService } from '../../shared/base.service';
import { HttpCacheInterceptor } from './http-cache.interceptor';
import { HttpCacheManager } from './http-cache.manager';

/**
 * Coordinates signalR and inits the component-specific interceptor.
 * Notifies when the cache is ready to use.
 * This service must always be injected at component level.
 */

@Injectable()
export class ScopedHttpCacheService extends BaseService {
  private _scopedCacheReady$ = new ReplaySubject(1);
  readonly scopedCacheReady$ = this._scopedCacheReady$.asObservable();

  private _httpCacheInterceptor: HttpCacheInterceptor;

  constructor(injector: Injector, private _httpCacheManager: HttpCacheManager) {
    super(injector);

    // We import the cache interceptor that should have been declared at the same component level.
    this._httpCacheInterceptor = injector.get(HttpCacheInterceptor);
  }

  /**
   * Register a new instance/scope in the current active signalR connection.
   */
  registerInstance(instanceId: string): void {
    this._httpCacheManager.emitRegisterInstanceWorker(instanceId);

    this._httpCacheManager.instanceRegistered$
      .pipe(filter((registeredInstanceId) => registeredInstanceId === instanceId))
      .subscribe((_) => {});

    // This is only valid if the interceptor service is provided in this component.
    this._httpCacheInterceptor.setInstanceId(instanceId);
  }
}
